<template>
  <div>
    <v-snackbar v-if="severity === 'info'" v-model="active" color="primary" timeout="60000" elevation="0">
      <v-progress-circular indeterminate class="mr-6" :width="2"
      />
      {{ message }}</v-snackbar>
    <v-snackbar v-if="severity === 'success'" style="font-size: 24px;" v-model="active" @input="closeSnackbar" color="#4caf50" :timeout="2500" elevation="0">
      <v-icon class="mr-4" large>fal fa-check-circle</v-icon>
      {{ message }}</v-snackbar>
    <v-snackbar v-if="severity === 'warning'" style="font-size: 24px;" v-model="active" @input="closeSnackbar" color="tracefyOrange" :timeout="4000" elevation="0">
      <v-icon class="mr-4" large>fal fa-exclamation-triangle</v-icon>
      {{ message }}</v-snackbar>
    <v-snackbar v-if="severity === 'error'" style="font-size: 24px;" v-model="active" multi-line @input="closeSnackbar" color="#f44336" :timeout="4000" elevation="0">
      <v-icon class="mr-4" large>fal fa-exclamation-circle</v-icon>
        {{ message.slice(0, 134) }}
      </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'Snackbar.vue',
  props: {
    snackbarActive: {
      type: Boolean,
      default: false
    },
    message: String,
    severity: String
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    active: {
      get () {
        return this.value
      },
      set (snackbarActive) {
        this.value = snackbarActive
      }
    }
  },
  methods: {
    closeSnackbar () {
      this.$emit('update-snackbar')
    }
  },
  watch: {
    snackbarActive (newValue) {
      this.value = newValue
    }
  }
}
</script>

<style>
.v-snack__content {
  font-size: 1rem;
  display: flex;
  align-items: center;
}
</style>
